import { render, staticRenderFns } from "./social-provident.vue?vue&type=template&id=55e6fd5a&scoped=true&"
import script from "./social-provident.vue?vue&type=script&lang=js&"
export * from "./social-provident.vue?vue&type=script&lang=js&"
import style0 from "./social-provident.vue?vue&type=style&index=0&id=55e6fd5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6fd5a",
  null
  
)

export default component.exports